export default function getYearIso(date) {
    const currentDate = new Date(date.getTime());
    currentDate.setDate(currentDate.getDate() + 3 - ((currentDate.getDay() + 6) % 7));
    return currentDate.getFullYear();
}
